import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactions } from "../RTK/Features/Transaction/TrnasactionSlice";

function Pagination() {
  const [selected, setSelected] = React.useState(0);
  const dispatch = useDispatch();
  const { noOfTotalRecords } = useSelector((state) => state.transaction);
  let { searchTerm, transactionType, order, limit } = useSelector(
    (state) => state.filter
  );
  let totalNoOfPage = Math.ceil(noOfTotalRecords / limit);
  let pageArray = Array.from({ length: totalNoOfPage }, (_, ind) => ind + 1);
  const handlePagination = (ind) => {
    setSelected(ind);

    dispatch(
      fetchTransactions({
        searchTerm,
        transactionType,
        order,
        limit,
        start: ind * limit,
        balanceRequired: false,
      })
    );
  };

  return (
    <div className="w-full flex items-center justify-end p-4">
      <div className="flex items-center justify-center gap-2">
        {pageArray.map((page, ind) => {
          let active = selected === ind ? "bg-sky-600 " : "bg-sky-900 ";
          return (
            <div
              key={ind}
              className={`${active} w-6 h-6 flex items-center justify-center text-slate-300	 p-1 cursor-pointer`}
              onClick={() => handlePagination(ind)}
            >
              {page}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Pagination;
